import React from 'react';
import { Link } from 'react-router-dom';

export const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="project-title">
          <Link to="/" aria-label="Go to home">
            PETPANDNCACTDNAOASK
          </Link>
        </h1>

        <nav className="nav">
          <Link to="/about">About</Link>
        </nav>
      </div>
    </header>
  );
};